<!-- RESERVATION -->
<section class="section-reservation-page bg-white">

  <div class="container">
    <div class="reservation-page">

      <!-- STEP -->
      <div>
        <ul style="list-style-type: none">
          <li *ngIf="isAdmin || (!(paidForConference$ | async) && !(paidForAccommodation$ | async))">
            <button class="btn btn-success" (click)="viewAddNewBooking()">Add New Booking</button>
          </li>
        </ul>
      </div>
      <!-- END / STEP -->

      <div class="row">

        <div class="col-sm-12">

          <!-- KENDO GRID-->
          <div class="table-responsive">

            <app-list-grid [bookings]="bookings$ | async" (onDeleteBooking)="deleteBooking($event)" (onEditBooking)="editCurrentBooking($event)"
              (onViewBooking)="viewBookingDetail($event)" (onViewAccommodationConfirmation)="viewAccommodationConfirmation($event)"
              (onViewConferenceConfirmation)="viewConferenceConfirmation($event)"></app-list-grid>

          </div>
        </div>

      </div>
    </div>
  </div>

</section>
<!-- END / RESERVATION -->


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/booking-list/booking-list.component.html